import { Link } from 'react-router';

export function Pagination({
  page,
  pageSize,
  total,
  makeHref,
}: {
  page: number;
  pageSize: number;
  total: number;
  makeHref: (page: number) => string;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <div className="flex items-center justify-between py-3 text-sm text-muted-foreground">
      <span>
        {from}–{to} of {total}
      </span>
      <div className="flex gap-2">
        {page > 1 ? (
          <Link className="ff-link" to={makeHref(page - 1)}>
            ← Previous
          </Link>
        ) : (
          <span className="opacity-40">← Previous</span>
        )}
        <span>
          Page {page} / {pages}
        </span>
        {page < pages ? (
          <Link className="ff-link" to={makeHref(page + 1)}>
            Next →
          </Link>
        ) : (
          <span className="opacity-40">Next →</span>
        )}
      </div>
    </div>
  );
}
